import React,{useEffect, useState} from 'react';
import banner from '../../images/banner.jpeg'
import clienteAxios from '../../config/axios';
import { makeStyles } from '@material-ui/core/styles';
import download from 'downloadjs'
import moment from 'moment'
import {Typography, CircularProgress ,Box, Backdrop}  from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
    image: {
        width:'100%',
        display:'block',
        position : 'fixed',
        zIndex : 0

      },
   
}));
function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="warning">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
const Carta = () => {
    const fecha = moment().format('D-MM-YY')
    const [value, setvalue] = useState(0);
    useEffect(() => {
        
        clienteAxios.get('/api/upload',{
            responseType: 'blob',
            onDownloadProgress : (progressEvent) => {
                const {loaded , total} = progressEvent;
                const porcentaje = Math.floor(loaded * 100 / total)
                setvalue(porcentaje)
            }
            })
            .then(res => {
                // console.log(res.data);    
                // const file = new Blob([res.data], {
                //     type: "application/pdf"
                //   });
                download(res.data, `carta_${fecha}.pdf`, res.headers['content-type'])  
                setvalue(0)
                //         //Build a URL from the file
        //         const fileURL = URL.createObjectURL(file);
        //   //Open the URL on new Window
        //     window.open(fileURL , '_blank');
            })
       // eslint-disable-next-line
    }, []);
    const classes = useStyles()
    return ( 
        <div >
            <Backdrop className={classes.backdrop} open={value > 0}>
                <CircularProgressWithLabel value={value}/>
            </Backdrop>
            <div>
            <Typography variant='h3' align='center'>Se esta descargando nuestra carta</Typography>
            <Typography variant='h4' align='center'>Disfrute de su visita</Typography>
            </div>
            <img src={banner} className={classes.image} alt='banner'></img>
        </div>
    );
}
 
export default Carta;